<script setup lang="ts">
import { computed, ref } from 'vue'
import { TokenListItem } from 'wepin-vue-component'
import { defaultCoinIcon } from '@/const'

const props = withDefaults(
  defineProps<{
    ticker?: string
    symbol?: string
    tickerSrc?: string
    networkSrc?: string
    chip?: string
  }>(),
  {
    ticker: '',
    symbol: '',
    tickerSrc: undefined,
    networkSrc: undefined,
    chip: '',
  },
)

const getTickerUrl = computed(() => {
  if (isErrorTokenIcon.value || !props.tickerSrc) {
    return defaultCoinIcon
  }
  return props.tickerSrc
})
const getNetworkUrl = computed(() => {
  if (isErrorNetworkIcon.value || !props.networkSrc) {
    return defaultCoinIcon
  }
  return props.networkSrc
})

const isErrorTokenIcon = ref(false)
const onErrorTokenIcon = () => {
  isErrorTokenIcon.value = true
}
const isErrorNetworkIcon = ref(false)
const onErrorNetworkIcon = () => {
  isErrorNetworkIcon.value = true
}
</script>

<template>
  <TokenListItem
    :ticker="ticker"
    :symbol="symbol"
    :ticker-src="getTickerUrl"
    :network-src="getNetworkUrl"
    :chip="chip"
    @error:load-token-icon="onErrorTokenIcon"
    @error:load-network-icon="onErrorNetworkIcon"
  />
</template>
